export default "__VITE_ASSET__35b42ec6__"